module.exports = __webpack_public_path__ + "media/src/assets/Images/RealEstateHome-52f5f57892ad5e565342480903e65b9c.png";